import { useMemo, useState } from "react"
import {
  MaterialReactTable,
  // createRow,
  useMaterialReactTable,
} from "material-react-table"
import DetalleImpresion from "../../Zonas/components/DetalleImpresion"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import { createTheme, ThemeProvider, useTheme, Box, Button, IconButton, Tooltip } from "@mui/material"
import { esES } from "@mui/material/locale"
import ImprimirIcon from "../../../assets/iconos/Impresion.ico"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import EditIcon from "@mui/icons-material/Edit"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import DetalleIcon from "../../../assets/iconos/Detalle.ico"
import DeleteIcon from "@mui/icons-material/Delete"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useNavigate } from "react-router-dom"
import CrearIcon from "../../../assets/iconos/Crear.ico"
import PosicionesPdf from "./PosicionesPdf"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../utils/date/HHMMSSFormatHour"

const CustomTable = () => {
  // para movernos a crear y editar
  const navigate = useNavigate()
  const columns = useMemo(
    () => [
      {
        accessorKey: "poscodigo",
        header: "Código",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "posdescripcion",
        header: "Descripción",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "posstatus",
        header: "Estado",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          let cellValue = cell.getValue()
          if (cellValue === "A") {
            cellValue = "ACTIVO"
          } else {
            cellValue = "INACTIVO"
          }
          return cellValue
        },
      },
      {
        accessorKey: "posusuisys",
        header: "Usuario Creacion",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "posfecisys",
        header: "Fecha de Creación",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
      },
      {
        accessorKey: "poshorisys",
        header: "Hora de Creación",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return new Date(cellValue).toLocaleTimeString()
        },
      },
      {
        accessorKey: "posusumsys",
        header: "Usuario Modifica",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "posfecmsys",
        header: "Fecha Modifica",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
      },
      {
        accessorKey: "poshormsys",
        header: "Hora Modifica",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return new Date(cellValue).toLocaleTimeString()
        },
      },
    ],
    [],
  )

  const { mutateAsync: createPosiciones, isPending: isCreatingPosiciones } = useCreatePosiciones()

  const {
    data: fetchedPosiciones = [],
    isError: isLoadingPosicionesError,
    isFetching: isFetchingPosiciones,
    isLoading: isLoadingPosiciones,
  } = useGetPosiciones()
  // useUpdateZona() hook de update, ,updateZona funcion que se ejecuta
  const { mutateAsync: updatePosicion, isPending: isUpdatingPosicion } = useUpdatePosicion()
  // useDeleteZona() hook de delete , usa la funcion deleteZona()
  const { mutateAsync: deletePosicion, isPending: isDeletingPosicion } = useDeletePosicion()
  // funcion que muestra el modal de eliminacion
  const openDeleteConfirmModal = async (row) => {
    if (window.confirm("¿Está seguro que quiere eliminar esta posicion?")) {
      await deletePosicion(row.original.poscodigo)
    }
  }
  const table = useMaterialReactTable({
    columns,
    data: fetchedPosiciones,
    enableEditing: true,
    initialState: {
      showColumnFilters: true,
    },
    enableRowActions: true,
    localization: { ...MRT_Localization_ES },
    getRowId: (row) => row.poscodigo,
    // si se cargar el error al importar los datos
    muiToolbarAlertBannerProps: isLoadingPosicionesError
      ? {
          color: "error",
          children: "Error en cargar las posiciones",
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Editar">
          <IconButton
            onClick={() => {
              navigate(`editar/${row?.original.poscodigo}`, {
                state: row?.original,
              })
            }}
          >
            <img src={DetalleIcon} alt="Editar" style={{ width: "20px" }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <img src={EliminarIcon} alt="Grabar" style={{ width: "20px" }} />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    state: {
      isLoading: isLoadingPosiciones,
      isSaving: isCreatingPosiciones || isUpdatingPosicion || isDeletingPosicion,
      showAlertBanner: isLoadingPosiciones,
      showProgressBars: isFetchingPosiciones,
    },
  })
  return (
    <>
      <MaterialReactTable table={table} />
      <CustomBackdrop isLoading={table.getState().isSaving} />
    </>
  )
}
function useGetPosiciones() {
  return useQuery({
    queryKey: ["Posiciones"],
    queryFn: async () => {
      // send api request here
      let response = await fetchwrapper("/Posiciones/getPosiciones")
      response = await response.json()
      response = response?.data
      console.log("data fetched", response)
      // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return response
    },
    refetchOnWindowFocus: false,
  })
}

// hooks a los que se les asigna una api y se encargan de actualizar el estado del componente
function useCreatePosiciones() {
  // hook para crear la zona
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (posicion) => {
      await new Promise((resolve) => setTimeout(resolve, 1000)) // fake api call
      return Promise.resolve()
    },
    onMutate: (newPosicion) => {
      queryClient.setQueryData(["Posiciones"], (prevPosiciones) =>
        prevPosiciones?.map((prevPosiciones) =>
          prevPosiciones.poscodigo === newPosicion.poscodigo ? newPosicion : prevPosiciones,
        ),
      )
    },
  })
}
function useUpdatePosicion() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (posicion) => {
      // send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)) // fake api call
      return Promise.resolve()
    },
    // client side optimistic update
    onMutate: (newPosicionInfo) => {
      queryClient.setQueryData(["Posiciones"], (prevPosiciones) =>
        prevPosiciones?.map((prevPosiciones) =>
          prevPosiciones.poscodigo === newPosicionInfo.poscodigo ? newPosicionInfo : prevPosiciones,
        ),
      )
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['bancoDePreguntas'] }), //refetch bancoDePreguntas after mutation, disabled for demo
  })
}
function useDeletePosicion() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (codigoPosicion) => {
      const options = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }

      const response = await fetchwrapper(`/Posiciones/deletePosicion/${codigoPosicion}`, options)
      return response
    },
    // actualizacion optimista
    onMutate: (codigoPosicion) => {
      queryClient.setQueryData(["Posiciones"], (prevPosiciones) =>
        prevPosiciones?.filter((posicion) => posicion.poscodigo !== codigoPosicion),
      )
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["Posiciones"] })
    },
    onSuccess: () => {
      alert("Posicion eliminada con exito")
    },
    onError: () => {
      alert("No se pudo eliminar la posicion")
    },
  })
}

const DataGridPosiciones = () => {
  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])
  const {
    data: fetchedPosiciones = [],
    isError: isLoadingPosicionesError,
    isFetching: isFetchingPosiciones,
    isLoading: isLoadingPosiciones,
  } = useGetPosiciones()
  const handleOpenModal = () => {
    setInfoGenerada(fetchedPosiciones) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }
  console.log("info pdf", fetchedPosiciones)
  const handleCloseModal = () => {
    setOpenModal(false)
    navigate("/home/dashboard/Posiciones")
  }
  const theme = useTheme()
  const navigate = useNavigate()
  return (
    <div>
      <Tooltip title="Crear Posicion">
        <Button color="primary" onClick={() => navigate("crear")} sx={{ marginBottom: "15px" }}>
          <img src={CrearIcon} alt="Crear" style={{ width: "30px" }} />
        </Button>
      </Tooltip>
      <Tooltip title="Imprimir">
        <Button color="primary" onClick={handleOpenModal} sx={{ marginBottom: "15px" }}>
          <img src={ImprimirIcon} alt="Imprimir" style={{ width: "30px" }} />
        </Button>
      </Tooltip>
      <DetalleImpresion
        open={openModal}
        handleClose={handleCloseModal}
        infoGenerada={fetchedPosiciones}
        nombrePdf={"Posiciones"}
        PdfComponent={PosicionesPdf}
      />
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable />
      </ThemeProvider>
    </div>
  )
}
export default DataGridPosiciones
